export const THM_GTM_EVENT_ACTION = 'THM Profiling Request';
export const THM_GTM_EVENT = 'THM Profiling';
export const THM_GTM_EVENT_LABEL = 'THM Request–Attempt';
export const THM_IFRAME_ID = 'threatmetrix_iframe';
export const THM_REFRESH_TIME_FOR_SSI = 25 * 60 * 1000;
export const THM_SCRIPT_TAG_ID = 'threatmetrix_script_tag';
export const THM_URL = 'https://thm.visa.com';
export const THM_URL_WITH_FP_TAG = 'https://thm.visa.com/fp/tags?';

const ENUMS = {
  THM_GTM_EVENT,
  THM_GTM_EVENT_ACTION,
  THM_GTM_EVENT_LABEL,
  THM_IFRAME_ID,
  THM_REFRESH_TIME_FOR_SSI,
  THM_SCRIPT_TAG_ID,
  THM_URL,
  THM_URL_WITH_FP_TAG
};

export default ENUMS;
